<template>
  <div>

      <router-view></router-view>
      <div class="sub-header">
          <div class="width-wrapper relative">
              <div class="page-title">Отчеты и отправка</div>


              <div class="header__save">
                  <a href="/api/reports/products_pharmacy_global" class="button button--inverse">Скачать текущий отчет</a>
                  <span  v-if="$store.state.user.role == 'HM'">
            <a href="#" class="button" @click.prevent="$router.push('add/')">Отправить данные</a>
          </span>
              </div>
          </div>



      </div>



    <div class="reports-list">

      <div class="reports-list-head">
        <div class="report-item report-item--head report-item__pharmacy report-item__pharmacy--head">Аптека</div>
        <div class="report-item report-item--head report-item__date report-item__date--head">Дата <br>отправки</div>
        <div class="report-item report-item--head report-item__groups report-item__groups--head">Товарных <br>групп</div>
        <div class="report-item report-item--head report-item__facings report-item__facings--head">Показов</div>
        <div class="report-item report-item--head report-item__report report-item__report--head">Статус</div>
        <div class="report-item report-item--head report-item__report report-item__report--head"></div>
      </div>

      <div class="reports-list-body">

        <div v-for="pharmacy in pharmacies" class="report-item-line">
          <div class="report-item report-item__pharmacy">{{pharmacy.title}}</div>
          <div class="report-item report-item__date">{{pharmacy.version !== null ? pharmacy.version.title : ''}}</div>
          <div class="report-item report-item__groups">{{pharmacy.version !== null ? pharmacy.version.clusterCount : ''}}</div>
          <div class="report-item report-item__facings">{{pharmacy.version !== null ?  pharmacy.version.facingCount : ''}}</div>
          <div class="report-item report-item__report">{{pharmacy.version !== null ?  statuses[pharmacy.version.status] : ''}}</div>
          <div class="report-item report-item__report"></div>
        </div>
      </div>

    </div>

  </div>
</template>


<script>
  import axios from 'axios';

  export default {
    name: 'reports',
    created() {
      this.loadVersions();
    },
    methods: {
      loadVersions() {
        const self = this;
        axios.get('/api/v2/versions/pharmacies/').then((response) => {
          self.isLoading = false;
          self.pharmacies = response.data;
        });
      },
      save() {
        axios.post('/api/pushnewversion/', {}).then(() => {
          document.location.reload();
        });
      },
    },
    data() {
      return {
        pharmacies: [],
        statuses: {
          NEW: 'Новая версия',
          SEEN: 'В работе',
          DONE: 'Сделано',
        },
      };
    },
  };

</script>


<style type="text/css" scoped="true" lang="less">

  .reports-list{
    width: 705px;
    box-sizing: border-box;
    background: #FFFFFF;
    border:1px solid #DFE4E8;
    margin: 30px auto;
    font-size: 0;
    border-radius:  4px;
    overflow: hidden;

  }
  .reports-list-head{
    border-bottom: 2px solid #E4E4E4;

  }

  .report-item-line{
    &:hover{
        background: #E4E4E4;
    }
  }

  .report-item{
    vertical-align: top;
    height: 38px;
    padding-top: 16px;
    display: inline-block;
    font-size: 12px;
    margin: 21px 21px;

    &--head{
      margin-bottom: 20px;
      margin-top: 0 !important;
      text-align: left !important;
    }


    &__date{
      width: 80px;
      /*text-align: center;*/
    }

    &__pharmacy{
      width: 100px;
    }
    &__groups{
      width: 86px;
    }
    &__facings{
      width: 82px;
    }

    &__report{
      width: 40px;
    }
  }

</style>


// WEBPACK FOOTER //
// Versions.vue?f1666122